module.exports = __webpack_public_path__ + "media/images/marisol/marisol4-4bc45251499f888442f5c12e723d430c.png";